import { Box, Drawer, Grid, ScrollArea, Stack } from '@mantine/core';
import InfoItem, { InfoItemInline } from 'components/ui/InfoItem';
import { TabDivider, TabDividerSpacing } from 'components/ui/Tabs';
import React from 'react';
import { ExtensionFragment, OrderFragment } from 'state/gql/_types';
import { formatDate, formatDuration, formatHour } from 'utils/dates';

export const TenantExtensions: React.FC<{currentItem:OrderFragment}> = ({currentItem:currentOrder}) => {

    const [opened, setOpened] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState<ExtensionFragment | null>(null);

    if (!currentOrder) return null

    return (
        <Box>

            <TabDividerSpacing label="Extensions" />

            <Stack spacing="xs">
                {currentOrder.extensions.map((i, k) => {
                    return (
                        <InfoItem
                            key={k}
                            label={`Extension #${i.extension_number} - ${formatDuration(i.rental_period)}`}
                            value={`${formatDate(i.start_date, 'MM/DD/YY')} - ${formatDate(i.end_date, 'MM/DD/YY')}`}
                            clickable
                            onClick={() => {
                                setCurrentItem(i as ExtensionFragment)
                                setOpened(true)
                            }}
                        />
                    )
                })}
            </Stack>

            <Drawer
                position="right"
                opened={opened}
                onClose={() => setOpened(false)}
                title={!!currentItem ? `Extension #${currentItem.extension_number}` : 'Extension'}
                size="xl"
                styles={(theme) => ({
                    header: {
                        borderBottom: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[5]}`,
                        marginBottom: 0,
                        padding: theme.spacing.xl
                    },
                    drawer: {
                        height: '100%',
                        minHeight: '100%',
                        maxHeight: '100%',
                    },
                })}
            >
                <Box

                    sx={{
                        height: "calc(100% - 77px)",
                        display: "grid",
                        gridTemplateRows: "1fr auto",
                    }}
                >
                    <Box sx={{ position: 'relative', height: '100%' }}>
                        <ScrollArea
                            style={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0
                            }}
                        >
                            <Box p="md">
                                {!!currentItem && (
                                    <React.Fragment>

                                        <TabDivider label="Extension Dates" />
                                        <Grid grow gutter="xs">
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Start Date" value={formatDate(currentItem.start_date)} />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="End Date" value={formatDate(currentItem.end_date)} />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Start Time" value={formatHour(currentItem.start_time)} />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="End Time" value={formatHour(currentItem.end_time)} />
                                            </Grid.Col>
                                        </Grid>

                                        <TabDividerSpacing label="Extension Terms" />
                                        <Grid grow gutter="xs">
                                            <Grid.Col xs={12}>
                                                <InfoItemInline label="Extension Period" value={formatDuration(currentItem.rental_period)} />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Day Rate" value={currentItem.day_rate} type="currency" />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Mile Rate" value={currentItem.mile_rate} type="currency" />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Other Fees" value={currentItem.other_fees} type="currency" />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Discount" value={currentItem.discount} type="currency" />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Subtotal" value={currentItem.sub_total} type="currency" />
                                            </Grid.Col>
                                            <Grid.Col xs={6}>
                                                <InfoItemInline label="Total" value={currentItem.order_total} type="currency" />
                                            </Grid.Col>
                                        </Grid>

                                        {!!currentItem.memo && (
                                            <React.Fragment>
                                                <TabDividerSpacing label="Memo / Notes" />
                                                <InfoItemInline value={currentItem.memo} empty />
                                            </React.Fragment>
                                        )}

                                        <TabDividerSpacing label="Info" />
                                        <Grid grow gutter="xs">
                                            <Grid.Col xs={12}>
                                                <InfoItemInline label="Created By" value={`${currentItem.agent.first_name} ${currentItem.agent.last_name}`} />
                                            </Grid.Col>
                                        </Grid>

                                    </React.Fragment>
                                )}
                            </Box>

                        </ScrollArea>
                    </Box>
                </Box>

            </Drawer>

        </Box>
    )

}

export default TenantExtensions 